import { Component, ViewChild, ElementRef, AfterViewInit, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'slider-video',
  templateUrl: './slider-video.component.html',
  styleUrls: ['./slider-video.component.scss']
})
export class SliderVideoComponent implements OnInit, AfterViewInit {

  @ViewChild('bgVideo') video!: ElementRef<HTMLVideoElement>;
  mute: boolean = true;

  isDesktop = false;
  pause: boolean = true;

  ngOnInit() {
    this.checkScreen();
  }

  @HostListener('window:resize')
  checkScreen() {
    this.isDesktop = window.innerWidth >= 992;
  }

  ngAfterViewInit(): void {

    const video = this.video.nativeElement;

    if (this.isDesktop) {
      video.muted = true;
      video.defaultMuted = true;

      const playVideo = () => {
        const promise = video.play();
        if (promise !== undefined) {
          promise.catch(() => {});
        }
      };

      if (video.readyState >= 2) {
        playVideo();
      } else {
        video.addEventListener('canplay', playVideo);
      }
    }
  }

  muteUnmute(mute) {
    const video = this.video.nativeElement;
    video.muted = mute;

    this.mute = mute;
  }

  play(status) {
    if (status) {
      const video = this.video.nativeElement;
      video.play();
    } else {
      const video = this.video.nativeElement;
      video.pause();
    }

    this.pause = !status;
  }

}